// TanStack Query loader for the region aggregates dataset. One-shot fetch,
// 24h staleTime (the dataset rebuilds quarterly with the pipeline).
import { useQuery } from '@tanstack/react-query';
import type { RegionsFile } from './types';

const QUERY_KEY = ['regions-it'] as const;

export function useRegionsIt() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: async (): Promise<RegionsFile> => {
      const res = await fetch('/data/regions_it.json');
      if (!res.ok) throw new Error(`regions_it.json: ${res.status}`);
      return res.json();
    },
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: Number.POSITIVE_INFINITY,
  });
}
